angular.module("gestioneQva.components", []).component("gestioneQva", {
    templateUrl: "ng/components/gestioneQva/gestioneQva.view.html",
    bindings: {
      
    },
    controllerAs: "gestioneQvaCtrl",
    controller: function gestioneQva(
      $contractService,
      FinancialCustomer,
      $modalService,
      $userService,
      $rootScope,
      $portalService,
      $location,
      $financialApiService,
      FinancialModel,
      QuestionarioQva
    ) {
      var self = this;
  
      self.$onInit = function () {
        self.supportModel = {
            contratto: null,
            modulo: null,
            isPending: false,
            listContract: []
        }
        self.customer = FinancialCustomer.build();
        self.financialModel = FinancialModel.build();
        self.index = 0;
        // self.contrattoSelected = { 
        //   "contratto": "1070451",
        //   "modulo": "1",
        //   "ndgCliente": "06412043",
        //   "ragSocCustomer": "NOONIC S.R.L."
        // }
      }
  
      self.next = function () {
       if (self.index == 1) {
          var codQuestionario = self.customer.metadata.questionarioQva.codQuestionario;
          var domande = self.customer.metadata.questionarioQva.domande;
          var prodotto = self.contrattoSelected.prodotto; //'MOB'
          $userService
              .sendQvaCruscotto(domande, codQuestionario, prodotto, 
                  self.supportModel.contratto, self.supportModel.modulo)
                  .then(function (response) {
                    self.esito = response.esito;
                    $modalService.openModal("qva-modal");
                  })
                  .catch(function (error) {
                    console.log(error);
                  });
        } else {
          $userService.getQvaData(self.contrattoSelected)
          .then(function(response) {
            self.customer.metadata.questionarioQva = response;
            self.esito = response.esito;
            if (!response.editable) {
              self.editable = false;
              self.data = response.dataCompilazione;
            } else {
              self.editable = true;
            }
            self.index = 1
          });
        }
      }

      self.back = function(){
        if (!self.editable) {
          self.supportModel.contratto = null;
          self.supportModel.modulo = null;
          self.supportModel.listContract = [];
          self.contrattoSelected = null;
          self.customer.metadata.questionarioQva = QuestionarioQva.build();
        }
        self.index = 0;
      }
        
      self.getContractsList = function () {
        self.contrattoSelected = null;
        self.customer.metadata.questionarioQva = QuestionarioQva.build();
        var contract = {
          numeroContratto: self.supportModel.contratto,
          modulo: self.supportModel.modulo
        }

        self.supportModel.isPending = true;

        $contractService.getCtrAssDistanza(contract)
          .then(function(response){
            self.supportModel.isPending = false;
            self.supportModel.listContract = response.allAppContractList;
          })
          .catch(function () {
            self.supportModel.isPending = false;
          })
      }

      self.closeModal = function() {
        $modalService.closeModal();
      }

      self.conferm = function() {
        self.customer.metadata.questionarioQva.esito = self.esito;
        $userService.submitQva(self.contrattoSelected, self.customer.metadata.questionarioQva)
        .then(function(response){
          if (response.success) {
            self.supportModel.contratto = null;
            self.supportModel.modulo = null;
            self.supportModel.listContract = [];
            self.contrattoSelected = null;
            self.customer.metadata.questionarioQva = QuestionarioQva.build();
            $rootScope.$broadcast('addAlert', {
              text: 'LBL_SUBMIT_QVA_OK'
            });
            self.index = 0;
          }
        })
        .catch(function (error) {
          console.log(error);
        });  
      }

      self.exportContratto = function(contratto) {
        self.contrattoSelected = contratto;
      }

      self.checkValidity = function() {
        if (self.index == 0) {
          return (self.supportModel.contratto && self.supportModel.modulo && self.contrattoSelected)
        } else {
          if (self.index == 1) {
            return self.customer.metadata.checkQva && self.editable;
          }
        }
      }
      
      self.backValidity = function () {
        return self.index == 0 ? false : true;
    }
    }
  })